import React from "react";
import { getColumns } from "./CompAppUserListColumns";
import { getCompAppUserData } from "../../../services/vehicle";
import OTAPagination from "../../OTAPagination";
import { Box } from "@mui/material";
import { detailsTabsBoxStyle } from "../../../services/Utils";

const CompAppUserList = ({ vehicleData }) => {
  const { device } = vehicleData;
  const columns = getColumns();
  return (
    <Box {...detailsTabsBoxStyle}>
      <OTAPagination
        columns={columns}
        extraFilters={[
          {
            columnField: "vehicleKey",
            operatorValue: "equals",
            value: device?.vehicleKey,
          },
        ]}
        endpointFn={getCompAppUserData}
        queryName={"compAppUser"}
        filterMode="server"
        getRowId={(row) => row?.compAppUserDetail?.email}
      />
    </Box>
  );
};

export default CompAppUserList;
